/**
 * English/Latin-only person names for booking guest/passenger/contact fields.
 * Matches PassengerFormChatView (`ascii_letters`) — spaces, hyphens, apostrophes allowed.
 */

/** UX copy shown immediately when Hebrew / non-Latin is typed into person-detail fields. */
export const ENGLISH_ONLY_PERSON_DETAILS_MESSAGE =
  "יש למלא את הפרטים באנגלית בלבד";

/**
 * Latin letters only; first char must be a letter.
 * Allows spaces, hyphens, apostrophes (e.g. Mary-Jane, O'Brien, Jean Luc).
 * @param {unknown} value
 * @returns {boolean}
 */
export function isEnglishOnlyPersonName(value) {
  const t = String(value ?? "").trim();
  if (!t) return true;
  return /^[A-Za-z][A-Za-z\s'-]*$/.test(t);
}

/**
 * @param {unknown} value
 * @returns {string|null} Hebrew message when invalid; null when empty or valid English.
 */
export function getEnglishOnlyPersonNameError(value) {
  if (isEnglishOnlyPersonName(value)) return null;
  return ENGLISH_ONLY_PERSON_DETAILS_MESSAGE;
}

/**
 * True when any of the given name parts fail English-only rules.
 * @param {...unknown} parts
 * @returns {boolean}
 */
export function hasNonEnglishPersonName(...parts) {
  return parts.some((p) => !isEnglishOnlyPersonName(p));
}
